import { Box, Button } from '@mui/material'
import { Trans } from '@lingui/macro'
import { FC } from 'react'
import { ContactFields } from './ContactFields'
// import Loading from 'egret/components/EgretLoadable/Loading'
import { ContactParsed } from 'app/services/sfAuth/sfData/sfContact'
import { AlertBanner } from 'app/views/common/alerts/AlertBanner'
import CustomButton from '../CustomButton'
import { ContactDialogType } from './useContactDialog'
import { isNil } from 'lodash'

interface ContactFieldsAddContactProps {
  loading: boolean
  values: ContactParsed
  onAdd: (params: { values: ContactParsed, isValid: boolean, initialValues: ContactParsed, dirty: boolean }) => Promise<void>
  onBack: () => void
  type?: ContactDialogType
  role?: string
}

export const ContactFieldsAddContact: FC<ContactFieldsAddContactProps> = ({
  loading,
  values,
  onAdd,
  onBack,
  type = 'contact-picker',
  role
}) => {
  return (
    <ContactFields
      initialValues={values}
      hiddenFields={{
        jobTitle: type !== 'project-affiliations',
        providedOrganizationName: type !== 'project-affiliations'
      }}
      initialTouched={{
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        phoneNumberCountryCode: true,
        jobTitle: true
      }}
      requiredFields={{
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        phoneNumberCountryCode: true,
        jobTitle: true
      }}
      readonlyFields={{
        firstName: true,
        lastName: true,
        email: loading,
        phoneNumber: loading,
        phoneNumberCountryCode: loading,
        providedOrganizationName: loading,
        jobTitle: loading
      }}
      title={
        <>
          <Box
            sx={{
              marginBottom: '25px',
              fontWeight: 'bold',
              fontSize: 20,
              lineHeight: '25px',
              color: 'primary.main',
              textAlign: 'center'
            }}
          >
            {type === 'project-affiliations' && !isNil(role)
              ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}>
                  <Trans>PROJECT_AFFILIATIONS_ADD_TITLE</Trans>
                  <Box>{role}</Box>
                </Box>)
              : <Trans>ADD_LEGAL_CONTACT_TITLE</Trans>}
          </Box>
          <AlertBanner
            title={<Trans>UPDATE_LEGAL_CONTACT_BANNER_TITLE</Trans>}
            description={
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div><Trans>UPDATE_LEGAL_CONTACT_BANNER_DESCRIPTION</Trans></div>
                <div><Trans>UPDATE_LEGAL_CONTACT_BANNER_ADD_DESCRIPTION</Trans></div>
              </div>
            }
            sx={{ marginBottom: '24px' }}
          />
        </>
      }
    >
      {({ values, isValid, initialValues, dirty }) => {
        const handleAddClick: () => Promise<void> = async () => {
          await onAdd({ values, isValid, initialValues, dirty })
        }
        const handleBackClick: () => void = () => {
          onBack()
        }

        return (
          <>
            <Box sx={{ display: 'flex', gap: '16px', marginBottom: '10px', marginTop: '22px' }}>
              <Button
                fullWidth
                color='primary'
                variant='contained'
                onClick={() => { handleAddClick().catch(err => console.error(err)) }}
                disabled={loading}
              >
                <Trans>ADD_CONTACT_BTN</Trans>
              </Button>
              <CustomButton
                variant='outlined'
                sx={{ height: '35px' }}
                onClick={handleBackClick}
                disabled={loading}
              >
                <Trans>BACK_BTN</Trans>
              </CustomButton>
            </Box>
            {/* {loading && (
              <div style={{ marginTop: 15, height: 100 }}>
                <Loading isNotFixed />
              </div>
            )} */}
          </>
        )
      }}
    </ContactFields>
  )
}
